import { FC, MouseEvent, ReactNode } from "react";
import cn from "classnames";
import { Divider } from "antd";
import { CloseIcon } from "@Icons/MainIcons";

type SheetHeaderProps = {
  label?: ReactNode;
  onClose: () => void;
  labelClassName?: string;
  closeClassName?: string;
};

const SheetHeader: FC<SheetHeaderProps> = ({ label, onClose, labelClassName, closeClassName = "bg-background-hover" }) => {
  const handleClose = (e: MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full items-center justify-between gap-1 px-4 py-2">
        <div className={cn("text-font-default", labelClassName)}>{label}</div>
        <button
          className={cn("flex items-center justify-center rounded-full p-1.5 cursor-pointer bg-font-inverted!", closeClassName)}
          onClick={handleClose}
        >
          <CloseIcon className="text-icon-default" />
        </button>
      </div>
      <Divider className="m-0!" />
    </div>
  );
};

export default SheetHeader;
